import * as React from "react";
import { isStringValidated } from "../Global/constants";
import { SweetAlerts } from "../UtilityFunctions/SweetAlerts";
import { Info16Regular, Info20Regular } from "@fluentui/react-icons";
import { Toggle, TooltipHost, Label, PrimaryButton  } from "office-ui-fabric-react";
import TextField from '../UtilityFunctions/CustomTextField';
import '../Home/Home.css';

function Settings(props) {

  const [siteURL,setSiteURL]=React.useState(localStorage.getItem("SiteURL")||"")
  const { SweetAlert: SweetalertSettings,SweetPrompt:SweetalertPrompt } = SweetAlerts("#SweetalertSettings");
  const [azureOpenAIData, setAzureOpenAIData] = React.useState<any>({
    Endpoint: "",
    APIkey: "",
    DeploymentName: "",
    AzureOpenAIToggle: false,
  });
  const [Copilot, setCopilot] = React.useState({ CopilotUrl:'', CopilotToggle:'No'})
  React.useEffect(()=>{
    const AzureAI:any= JSON.parse(localStorage.getItem("AzureAI") || "{}")
    const Copilot:any= JSON.parse(localStorage.getItem("Copilot") || "{}")
    const AzureAIData={
      ...AzureAI,
    }
    const CopilotData = {
      ...Copilot,
    }
    setAzureOpenAIData(AzureAIData)
    setCopilot(CopilotData)
  },[])
  
  // console.log(props)
  const saveSiteCredential=()=>{
    const urlInput = siteURL?.trim();
    const isValid = azureOpenAIData?.AzureOpenAIToggle ? azureOpenAIData?.APIkey?.trim()?.length > 0 && azureOpenAIData?.DeploymentName?.trim()?.length > 0 : Copilot?.CopilotToggle === 'Yes' ? Copilot?.CopilotUrl?.trim()?.length > 0 : true;
    if (isStringValidated(urlInput) && isValid) {
      SweetalertPrompt("warning",'Are you sure you want to update the credentials?').then((c)=>{
        if(c.isConfirmed){
     
          const tenantUrlPattern = /^https:\/\/[a-zA-Z0-9-]+\.((sharepoint\.com)|(onmicrosoft\.com))(\/.*)?$/;
          if (!tenantUrlPattern.test(urlInput)) {
            SweetalertSettings('error',`'Invalid tenant URL. Please use a valid URL like https://tenantname.sharepoint.com';`)
            // messageLabel.textContent = 'Invalid tenant URL. Please use a valid URL like https://tenantname.sharepoint.com';
            return;
          }else{
            const tenantURL= urlInput?.split("/sites")[0]
            localStorage.setItem("SiteURL", urlInput);
            localStorage.setItem("TenantURL", tenantURL);
            localStorage.setItem("AzureAI",JSON.stringify(azureOpenAIData))
            localStorage.setItem("Copilot",JSON.stringify(Copilot))
            SweetalertSettings('success','Site URL submitted successfully')
          }
        }
      })
    }else {
      if(!urlInput){
        SweetalertSettings('error',"Please enter a site URL")
      } else if (!azureOpenAIData?.Endpoint?.trim() && azureOpenAIData?.AzureOpenAIToggle){
        SweetalertSettings("error", "Please enter Azure AI endpoint");
      } else if(!azureOpenAIData?.APIkey?.trim() && azureOpenAIData?.AzureOpenAIToggle){
        SweetalertSettings("error", "Please enter Azure AI api key");
      } else if(!azureOpenAIData?.DeploymentName?.trim() && azureOpenAIData?.AzureOpenAIToggle){
        SweetalertSettings("error", "Please enter Azure AI deployment name");
      } else if(!Copilot?.CopilotUrl?.trim()){
        SweetalertSettings("error", "Please enter PA Url for copilot");
      }
    }
  }
  const handleToggleChange = (key) => (_, checked) => {
    if (checked) {
      setAzureOpenAIData((pre)=>({...pre, AzureOpenAIToggle: key === 'openAI'}))
      setCopilot((pre)=>({...pre, CopilotToggle: key === 'Copilot' ?'Yes' : 'No'}))
    } else {
      if (key === 'openAI') {
      setAzureOpenAIData((pre) => ({ ...pre, AzureOpenAIToggle: false }));
    } else {
      setCopilot((pre) => ({ ...pre, CopilotToggle: 'No' }));
    }
    }
  };
  return (
    <div id='SweetalertSettings'>
      {/* <div>
        <div className={"LableAndInfo"}>
          <Label>{"Client ID"}</Label>
          <Tooltip withArrow content={"Please enter Client Id (ex: '1xxxxx28-axx5-4c0a-bxxa-97exxxx5c4xx')"} relationship="label">
            <Info20Regular style={{ marginLeft: "5px" }} />
          </Tooltip>
          
        </div>
        <Input placeholder="1xxxxx28-axx5-4c0a-bxxa-97exxxx5c4xx"/>
      </div> */}

      <div className="Integration">
        <div className={"LableAndInfo"} style={{paddingBottom:'5px'}}>
          <Label required styles={{root: { '::after': { paddingRight: "5px" }}}}>{"Site URL"}</Label>
          <TooltipHost content={"Please enter Site URL (ex:'https://yourtenant.sharepoint.com/sites/yoursitename)"}>
            <Info20Regular style={{marginTop:'5px',width: '17px'}} />
          </TooltipHost>
          
        </div>
        <TextField placeholder="https://yourtenant.sharepoint.com/sites/yoursitename" value={siteURL} title={siteURL} onChange={(ev,Newval)=>{
          setSiteURL(Newval)
        }} />
      </div>
      <div style={{margin:'10px 0px 40px 0px'}}>
                <div className='Integration'>
                <div className='SettingsIntegration'>
                 <div className='IntegrationInfo'>
                  <Label>Azure Open AI</Label>
                 <TooltipHost content={'Please follow the Kb Article for activation of Azure AI.'}>
                        <Info16Regular  style={{marginTop:'5px'}}/>
                      </TooltipHost></div>
                       <Toggle
                        checked={azureOpenAIData?.AzureOpenAIToggle}
                        onChange={handleToggleChange('openAI')}
                        onText="On"
                        offText="Off">
                      </Toggle></div>
                      {azureOpenAIData?.AzureOpenAIToggle && <div>
                    <div  >
                      <TextField
                      label="Azure AI Endpoint"
                      required
                        name="Endpoint"
                        placeholder={"Enter Endpoint"}
                        onChange={(_event, newVal) => {
                          setAzureOpenAIData((c) => ({
                            ...c,
                            Endpoint: newVal
                          }));
                        }}
                        value={azureOpenAIData?.Endpoint}
                        title={azureOpenAIData?.Endpoint}
                      />
                    </div>
      
                    <div >
                     
                      <TextField
                        name="APIkey"
                        required
                        label={"Azure AI API Key"}
                        placeholder={"Enter Azure Key"}
                        onChange={(_event, newVal) => {
                          setAzureOpenAIData((c) => ({
                            ...c,
                            APIkey: newVal
                          }));
                        }}
                        value={azureOpenAIData?.APIkey}
                        title={azureOpenAIData?.APIkey}
                      />
                    </div>
      
                    <div >
                      <TextField
                      label={"Azure AI Deployment Name"}
                      required
                        name="DeploymentName"
                        placeholder={"Enter Deployment Name"}
                        onChange={(_event, newVal) => {
                          setAzureOpenAIData((c) => ({
                            ...c,
                            DeploymentName: newVal
                          }));
                        }}
                        title={azureOpenAIData?.DeploymentName}
                        value={azureOpenAIData?.DeploymentName}
                      />
                    </div>
              </div>}
              </div>
              <div style={{ marginTop:'10px'}} className="Integration" >
                <div className="SettingsIntegration">
                  <div className="IntegrationInfo">
                 <Label>Copilot Integration</Label>
                 <TooltipHost content={'Enable or disable Copilot integration. Enter the configured Power Automate (PA) URL and click Save to activate the copilot feature.'}>
                    <Info16Regular style={{marginTop:'6px'}}/>
                      </TooltipHost></div>
                       <Toggle
                        checked={Copilot?.CopilotToggle=='Yes'}
                        onChange={handleToggleChange('Copilot')}
                        onText="On"
                        offText="Off">
                      </Toggle></div>
                      {Copilot?.CopilotToggle=='Yes' && <TextField
                      label={"Configured PA Url"}
                      required
                      placeholder={"Enter configured PA Url"}
                      onChange={(_event, newVal) => {
                        setCopilot((c) => ({
                          ...c,
                          CopilotUrl: newVal
                        }));
                      }}
                      title={Copilot?.CopilotUrl}
                      value={Copilot?.CopilotUrl}/>
                      }
                  </div>
                  <div style={{ marginTop: "1rem" }}>
              <PrimaryButton
                text={"Save"}
                className={"savebutton"}
                onClick={() => saveSiteCredential()}
              ></PrimaryButton>
            </div>
            </div>
      </div>
  );
}

export default Settings;
